<template>
  <q-btn flat small color="negative" @click="handleDelete(id)" :disable="readonly">
    <q-icon name="delete" color="negative"></q-icon>
  </q-btn>
</template>
<script>
export default {
  name: 'GridCellActionDelete',
  props: {
    column: Object,
    row: Object,
    id: Number,
    resource: String,
    trashed: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: () => false
    }
  },
  methods: {
    handleDelete (id) {
      const columns = this.$store.getters[`${this.resource}/columns`]
      const columnLabel = columns.find(c => c.isTitle)
      const model = Object.assign({}, this.$store.getters[`${this.resource}/find`](id))
      let label = columnLabel ? model[columnLabel.field] : 'this row'
      let message = `Are you sure you want to remove ${label}?`
      let method = 'apiDelete'
      if (this.trashed) {
        message = `WARNING: This will PERMANENTLY delete this record. There is NO GOING BACK. Please be sure!. ${message}`
        if (this.resource === 'company') {
          message = `WARNING: This will PERMANENTLY delete this company AND all persons related to it. There is NO GOING BACK. Please be sure!. ${message}`
        }
        method = 'apiForceDelete'
      }
      this.$q
        .dialog({
          title: 'Confirm Delete',
          message,
          cancel: true,
          ok: {
            push: true,
            color: 'negative',
            outline: true,
            flat: true,
            label: 'Confirm Delete'
          }
        })
        .then(async () => {
          await this.$store.dispatch(`${this.resource}/${method}`, { id: id, client: this.$axios })
          // make sure item wasn't selected
          let selected = this.$store.state[this.resource].settings.selected.slice(0)
          const itemIndex = selected.findIndex(s => parseInt(s.id) === parseInt(id))
          if (itemIndex !== -1) {
            selected.splice(itemIndex, 1)
            this.$store.commit(`${this.resource}/SET_SETTING`, {
              field: 'selected',
              value: selected
            })
          }
          this.$q.notify({
            message: `${label} DELETED successfully!`,
            type: 'positive',
            timeout: 10000
            // actions: [
            //   {
            //     label: 'Undo Delete',
            //     handler: async () => {
            //       try {
            //         const data = await this.$store.dispatch(`${this.resource}/apiRestore`, { id: id, client: this.$axios })
            //         this.$q.notify({
            //           message: `${label} has been RESTORED successfully`,
            //           type: 'positive'
            //         })
            //         if (data) {
            //           await this.$store.commit(`${this.resource}/API_INSERT`, model)
            //         }
            //       } catch (e) {
            //         this.$q.notify({
            //           message: `${label} could not be RESTORED`,
            //           type: 'negative'
            //         })
            //       }
            //     }
            //   }
            // ]
          })
        })
        .catch(e => {})
    }
  }
}
</script>
